import React, { useState } from "react";
import CignaTraumaTwoYearsFreeSpecialOfferModal from "../../../../Modals/SpecialOffersModals/CignaTraumaTwoYearsFreeSpecialOfferModal/CignaTraumaTwoYearsFreeSpecialOfferModal";

const CignaTraumaTwoYearsFreeSpecialOffer: React.FC = () => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <React.Fragment>
            <CignaTraumaTwoYearsFreeSpecialOfferModal
                isOpen={isOpen}
                onClose={() => setIsOpen(false)}
            />
            <a onClick={() => setIsOpen(true)}>Free Trauma cover for 2 years</a>
        </React.Fragment>
    );
};

export default CignaTraumaTwoYearsFreeSpecialOffer;
